import Icon from '@/asset/Icon'
import { isLoggedInAtom } from '@/state'
import * as http from '@/util/http'
import { getDefaultStore, useAtom } from 'jotai'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { useNavigate, useLocation } from 'react-router-dom'
import { cursorPointer, frostedGlass, logo } from './style.css'
import { redirectToLabBaseAuthPage } from '@/util/auth'
import { LogInIcon, LogOutIcon } from 'lucide-react'

export default function NaviTop() {
  const [isLoggedIn] = useAtom(isLoggedInAtom)
  const navigate = useNavigate()
  const location = useLocation()
  const isOnboardingPage = location.pathname.startsWith('/onboarding')
  return (
    <Navbar expand="lg" fixed="top" className={frostedGlass} style={{ fontSize: '0.8rem' }}>
      <Container fluid>
        <Navbar.Brand
          className={`d-flex justify-content-center align-items-center ${cursorPointer}`}
          onClick={() => !isOnboardingPage && navigate('/')}
        >
          <Icon type="logo" className={`me-1 ${logo}`} />
        </Navbar.Brand>
        <Nav variant="tabs">
          <Nav.Item>
            {isLoggedIn ? (
              <Button
                variant="outline-secondary"
                onClick={async () => {
                  await http.del('/auth/v1/token')
                  localStorage.setItem('isLoggedIn', 'false')
                  const store = getDefaultStore()
                  store.set(isLoggedInAtom, false)
                  navigate('/intro')
                }}
                className="d-flex flex-row justify-content-center align-items-center"
              >
                <LogOutIcon className="me-1" />
                ログアウト
              </Button>
            ) : (
              <Button
                onClick={() => {
                  redirectToLabBaseAuthPage('/login', 'signin')
                }}
                className="d-flex flex-row justify-content-center align-items-center"
                variant="outline-primary"
              >
                <LogInIcon className="me-1" />
                ログイン
              </Button>
            )}
          </Nav.Item>
        </Nav>
      </Container>
    </Navbar>
  )
}
